import gql from 'graphql-tag'
import { ProfileFieldsFragment } from '../profile'

export const ExternalSchoolWithProfileFieldsFragment = gql`
  fragment ExternalSchoolWithProfileFields on ExternalSchool {
    profile {
      ...ProfileFields
      programOfferings {
        id
        slug
      }
    }
  }

  ${ProfileFieldsFragment}
`
